import { IGerenciarControleReparo } from "../../../Interfaces/AssistenciaTecnica/GerenciarControleReparo/GerenciarControleReparoInterface";
import { atualizarDadosControleReparo, obterDadosControleReparo } from "../../../Services/AssistenciaTecnica/GerenciarControleReparo/GerenciarControleReparoServices";
import { Controller } from "../../Controller";

export async function ObterDadosControleReparoController(
    idCaso: number
) {
    return Controller(obterDadosControleReparo(idCaso));
}

export async function AtualizarDadosControleReparoController(
    data: IGerenciarControleReparo
) {
    return Controller(atualizarDadosControleReparo(data));
}
